import { css, CSSResult } from 'lit'
import {
  csColorAction,
  csColorBackground,
  csColorBorder,
  csColorFunctional,
  csColorText
} from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder, csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cseSelectable = {
  backgroundColor: css`var(--cse-selectable-background-color, ${csColorBackground.primary})`,
  backgroundColorDisabled: css`var(--cse-selectable-background-color-disabled, ${csColorBackground.disabled})`,
  borderColor: css`var(--cse-selectable-border-color, ${csColorBorder.light})`,
  borderColorHover: css`var(--cse-selectable-border-color-hover, ${csColorFunctional.infoHover})`,
  borderRadius: css`var(--cse-selectable-border-radius, ${csBorder.radiusMinimal})`,
  colorDisabled: css`var(--cse-selectable-color-disabled, ${csColorText.muted})`,
  gap: css`var(--cse-selectable-gap, ${csSpacing.spacing04})`,
  paddingBlock: css`var(--cse-selectable-padding-y, ${csSpacing.spacing07})`,
  paddingInline: css`var(--cse-selectable-padding-x, ${csSpacing.spacing07})`,
  smallPaddingBlock: css`var(--cse-selectable-padding-y-small, ${csSpacing.spacing06})`,
  smallPaddingInline: css`var(--cse-selectable-padding-x-small, ${csSpacing.spacing06})`,
  extraSmallPaddingBlock: css`var(--cse-selectable-padding-y-extra-small, ${csSpacing.spacing05})`,
  extraSmallPaddingInline: css`var(--cse-selectable-padding-x-extra-small, ${csSpacing.spacing05})`,
  textAlign: css`var(--cse-selectable-text-align, start)`,
  minWidth: css`var(--cse-selectable-min-width, auto)`,

  selectedBackgroundColor: css`var(--cse-selectable-selected-background-color, ${csColorBackground.info})`,
  selectedBorderColor: css`var(--cse-selectable-selected-border-color, ${csColorFunctional.info})`,
  titleColorHover: css`var(--cse-selectable-title-color-hover, ${csColorAction.linkPrimaryHover})`,
  overlayColor: css`var(--cse-selectable-overlay-color, ${csColorFunctional.info})`,
  overlayBackgroundColor: css`var(--cse-selectable-overlay-background-color, ${csColorFunctional.infoOverlay})`
}

export const style: CSSResult = css`
  .cse-selectable {
    --cse-text-text-align: ${cseSelectable.textAlign};
    background-color: ${cseSelectable.backgroundColor};
    color: inherit;
    border-width: ${csBorder.width};
    border-style: solid;
    border-color: ${cseSelectable.borderColor};
    border-radius: ${cseSelectable.borderRadius};
    display: flex;
    flex-direction: column;
    font: inherit;
    gap: ${cseSelectable.gap};
    padding-block: ${cseSelectable.paddingBlock};
    padding-inline: ${cseSelectable.paddingInline};
    position: relative;
    text-align: ${cseSelectable.textAlign};
    transition-duration: ${csTransition.duration};
    transition-timing-function: ${csTransition.timingFunction};
    transition-property: color, background-color, border-color;
    width: 100%;
    min-width: ${cseSelectable.minWidth};
  }

  .cse-selectable.selectable, .cse-selectable.selected {
    cursor: pointer;
  }

  .cse-selectable.selected, .cse-selectable.loading {
    background-color: ${cseSelectable.selectedBackgroundColor};
    border-color: ${cseSelectable.selectedBorderColor};
  }

  .cse-selectable.selectable:hover {
    border-color: ${cseSelectable.borderColorHover};
  }

  .cse-selectable.selectable:hover ::slotted(.title) {
    --cse-text-color: ${cseSelectable.titleColorHover};
  }

  .overlay {
    color: ${cseSelectable.overlayColor};
    display: none;
    inset: 0;
    overflow: hidden;
    position: absolute;
  }

  .cse-selectable.loading .overlay {
    --cse-icon-color: ${cseSelectable.overlayColor};
    align-items: center;
    background-color: ${cseSelectable.overlayBackgroundColor};
    display: flex;
    justify-content: center;
  }

  .cse-selectable:disabled {
    background-color: ${cseSelectable.backgroundColorDisabled};
    color: ${cseSelectable.colorDisabled};
  }

  .cse-selectable.fill {
    height: 100%;
  }

  /* SIZES */
  .size-small {
    padding-block: ${cseSelectable.smallPaddingBlock};
    padding-inline: ${cseSelectable.smallPaddingInline};
  }

  .size-extra-small {
    padding-block: ${cseSelectable.extraSmallPaddingBlock};
    padding-inline: ${cseSelectable.extraSmallPaddingInline};
  }
`
